import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export const Layout = ({ children }) => {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};
